import { render } from "./editarSubAdministrador.vue?vue&type=template&id=fc898854&scoped=true"
import script from "./editarSubAdministrador.vue?vue&type=script&lang=js"
export * from "./editarSubAdministrador.vue?vue&type=script&lang=js"

import "./editarSubAdministrador.vue?vue&type=style&index=0&id=fc898854&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc898854"]])

export default __exports__